module.exports = __webpack_public_path__ + "static/media/BRL.b8c64cd9.png";